import { Controller } from "@hotwired/stimulus"

// 중첩 폼(공사범위·조직도·공정 등)의 행 추가 / 삭제 처리
export default class extends Controller<HTMLElement> {
  static targets = ["list", "template"]

  declare readonly listTarget: HTMLElement
  declare readonly templateTarget: HTMLTemplateElement

  add(event: Event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, `${Date.now()}${this.listTarget.children.length}`)
    this.listTarget.insertAdjacentHTML("beforeend", html)
    const row = this.listTarget.lastElementChild as HTMLElement | null
    row?.querySelector<HTMLInputElement>("input[type=text], textarea, select")?.focus()
  }

  remove(event: Event) {
    event.preventDefault()
    const row = (event.currentTarget as HTMLElement).closest<HTMLElement>(".nested-row")
    if (!row) return
    const destroy = row.querySelector<HTMLInputElement>("input[name*='_destroy']")
    const persisted = row.querySelector<HTMLInputElement>("input[name*='[id]']")
    if (destroy && persisted) {
      destroy.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
  }
}
